import React from 'react';
import { API } from './API';
import { APIData } from '../../services/model';
import { sorting, StoreState } from '../Store';

type APIListProps = { isInternal: boolean; apis: APIData[]; currentSort: string };

const getSortClass = (currentSort: string): string =>
    'booticon.bi bi-sort-alpha-' + (currentSort === sorting.asc ? 'down' : 'up') + ' clickable';

const sortList = (currentSort: string) => {
    StoreState.set({ sort: currentSort === sorting.asc ? sorting.desc : sorting.asc });
};

export const APIList: React.FC<APIListProps> = ({ isInternal, apis, currentSort }) => (
    <table className="table col-12 ">
        <thead>
            <tr>
                <th
                    scope="col"
                    className="cursor-pointer col-3"
                    onClick={() => {
                        sortList(currentSort);
                    }}
                >
                    Name <i className={getSortClass(currentSort)}></i>
                </th>
                <th scope="col" className="col-7">
                    Description
                </th>
                {isInternal && (
                    <th scope="col" className="col-2">
                        Request stats
                    </th>
                )}
                <th scope="col" className="col-1">
                    Version
                </th>
            </tr>
        </thead>
        <tbody>
            {apis.map((data, index) => (
                <API isInternal={isInternal} metadata={data.metadata} key={index} />
            ))}
        </tbody>
    </table>
);
